export type PaymentError = {
    id: string,
    message: string
}

export const GENERIC: PaymentError = {
    id: 'generic',
    message: 'Something went wrong. Please check your details and try again.'
};

export const AUTHENTICATION_FAILED: PaymentError = {
    id: 'auth-failed',
    message: '3-D Secure authentication failed. Please try again.'
};
export const DECLINED: PaymentError = {
    id: 'declined',
    message: 'Payment has not been authorised. Please try again.'
};

export const CARD_INCOMPLETE: PaymentError = {
    id: 'card-incomplete',
    message: 'Your card details are incomplete. Please try again.'
};

export const CURRENCY_COUNTRY_INVALID: PaymentError = {
    id: 'currency-country-invalid',
    message: 'Sorry, the currency selected for Klarna payment doesn’t match the country in your billing address. Please try again or choose a new payment method.'
};
